import React, { useState } from "react";
import "./LayersPopup.scss";

export interface LayerItem {
    id: string;
    label: string;
    checked: boolean;
    disabled?: boolean;
    dividerBefore?: boolean;
}

export interface LayersPopupProps {
    items: LayerItem[];
    onToggle: (id: string) => void;
    renderTrigger: (props: { isOpen: boolean; onToggle: () => void }) => React.ReactNode;
    title?: string;
    /** Optional element rendered between the header and item list (e.g. a divider line) */
    headerDivider?: React.ReactNode;
    placement?: "left" | "above";
    imgSize?: number;
    className?: string;
}

const LayersPopup: React.FC<LayersPopupProps> = ({
    items,
    onToggle,
    renderTrigger,
    title = "Layers",
    headerDivider,
    placement = "left",
    imgSize = 14,
    className = "",
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen((v) => !v);

    return (
        <div className="layers-popup-wrapper">
            {isOpen && (
                <div className={`layers-popup layers-popup--${placement}${className ? ` ${className}` : ""}`}>
                    <div className="layers-popup__header">{title}</div>
                    {headerDivider}
                    <div className="layers-popup__items">
                        {items.map((item) => (
                            <React.Fragment key={item.id}>
                                {item.dividerBefore && <div className="layers-popup__divider" />}
                                <div
                                    className={`layers-popup__item${item.disabled ? " layers-popup__item--disabled" : ""}`}
                                    onClick={() => !item.disabled && onToggle(item.id)}
                                >
                                    <img
                                        src={
                                            item.checked && !item.disabled
                                                ? require("../../../assets/images/svgs/roundChecked.svg").default
                                                : require("../../../assets/images/svgs/roundUnChecked.svg").default
                                        }
                                        height={imgSize}
                                        width={imgSize}
                                        alt={item.checked ? "checked" : "unchecked"}
                                    />
                                    <span>{item.label}</span>
                                </div>
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            )}
            {renderTrigger({ isOpen, onToggle: toggle })}
        </div>
    );
};

export default LayersPopup;
